import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";

function SvgVerify(props) {
  return _jsxs("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [_jsx("mask", Object.assign({
      id: "verify_svg__a",
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 64,
      height: 64
    }, {
      children: _jsx("path", {
        fill: "#fff",
        d: "M0 0h64v64H0z"
      }, void 0)
    }), void 0), _jsxs("g", Object.assign({
      mask: "url(#verify_svg__a)"
    }, {
      children: [_jsx("path", {
        d: "M25.5 19a7.5 7.5 0 100-15 7.5 7.5 0 000 15zM40 29c-.5-2.5-1.469-5-7.922-5H19.95c-6.47 0-9.776 3.38-8.773 9.89.844 5.402 1.097 7.237 1.886 11.732C13.853 50.116 16.902 53 22.5 53",
        stroke: "#7373FF",
        strokeWidth: 3,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }, void 0), _jsx("path", {
        d: "M40 60c7.18 0 13-5.82 13-13s-5.82-13-13-13-13 5.82-13 13 5.82 13 13 13z",
        stroke: "#FF6652",
        strokeWidth: 3,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }, void 0), _jsx("path", {
        d: "M36.115 45.178a1.5 1.5 0 00-2.23 2.007l2.23-2.007zM38.437 50l-1.114 1.004a1.5 1.5 0 002.133.097L38.437 50zm8.582-5.9a1.5 1.5 0 10-2.038-2.2l2.038 2.2zm-13.134 3.085l3.438 3.819 2.23-2.008-3.438-3.818-2.23 2.007zm5.571 3.916l7.563-7-2.038-2.202-7.562 7 2.037 2.202z",
        fill: "#FF6652"
      }, void 0)]
    }), void 0)]
  }), void 0);
}

export default SvgVerify;